export default __webpack_public_path__ + "static/elevate-316444c888b19b15d09a64e0060c44de.svg";